import React from 'react';
import { ArrowLeft } from 'lucide-react';

/**
 * Header for screens that are not tied to a hospital (Clinical Tools and its tools).
 * Same shape as HospitalHeader: white, a thin accent band, an icon tile, the title in
 * the display serif and the subtitle in the accent colour.
 */
const ToolHeader = ({ title, subtitle, icon: Icon, accent = '#6d28d9', backLabel = 'Back', onBack }) => (
  <div className="bg-white dark:bg-gray-800">
    <div className="h-1.5" style={{ backgroundColor: accent }} aria-hidden="true" />
    <div className="px-6 pt-4 pb-5">
      <button onClick={() => { onBack(); }} className="flex items-center gap-1.5 mb-4 text-gray-500 dark:text-gray-400 hover:opacity-80">
        <ArrowLeft size={20} /><span className="text-[15px]">{backLabel}</span>
      </button>
      <div className="flex items-center gap-4">
        {Icon && (
          <div className="w-12 h-12 rounded-2xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: `${accent}1f`, color: accent }}>
            <Icon size={26} />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <h1 className="font-display text-[22px] leading-tight font-bold text-gray-900 dark:text-white">{title}</h1>
          {subtitle && <p className="text-sm font-medium mt-1" style={{ color: accent }}>{subtitle}</p>}
        </div>
      </div>
    </div>
  </div>
);

export default ToolHeader;
